import HttpClient from "../../clients/HttpClient";
import { WalletTransaction, WalletTransactionListItem } from "../../models/Wallet";


export default class WalletService {
  static httpClient: HttpClient = HttpClient.getInstance("backend", process.env.REACT_APP_API_URL);

  /**
   * Get current wallet balance
   * @returns balance in cents
   */
  /* -- unused
  public static async getBalanceCents(ownerAccountId: number): Promise<number> {
    return this.httpClient.post(`/accounts/${ownerAccountId}/admin_read_wallet`).then((res) => {
      return res.data.balanceCents;
    });
  }
  */

  /**
   * Performs a wallet transaction
   * @returns Transaction id (string)
   */
  public static async createWalletTransaction(data: WalletTransaction): Promise<string> {
    return this.httpClient.put(`/accounts/${data.ownerAccountId}/admin_update_wallet`, data).then((res) => {
      return res.data.transactionId;
    });
  }

  /**
   * Get wallet transactions for a wallet
   * @returns TransactionListItemDTO
   */
  public static async getWalletTransactions(ownerAccountId: number): Promise<Array<WalletTransactionListItem>> {
    return this.httpClient.post(`/accounts/${ownerAccountId}/admin_read_wallet_transactions`, {}).then((res) => {
      return res.data.map((row) => new WalletTransactionListItem(row));
    });
  }
}